import { type FC } from 'react'

import { type ProspectDto } from '@api'

import { DataTable } from '@/components/ui/table/controlled-pagination/DataTable'
import { usePagination } from '@/utils/pagination/pagination-context'

import { PROSPECTS_TABLE_COLUMNS } from './constants'

interface Props {
  data: ProspectDto[]
  isLoading: boolean
  pageCount: number
}

export const ProspectsTable: FC<Props> = ({ data, isLoading, pageCount }) => {
  const { pagination, setPagination, setSorting, sorting } = usePagination()

  return (
    <DataTable
      enableSorting
      sortingState={sorting}
      onSortingChange={setSorting}
      enablePagination
      paginationState={pagination}
      onPaginationChange={setPagination}
      columns={PROSPECTS_TABLE_COLUMNS}
      data={data}
      tbodyMinHeight={false}
      isLoading={isLoading}
      pageCount={pageCount}
      testId="prospects-table"
    />
  )
}
